module.exports = __webpack_public_path__ + "img/deltourlogo.8b27823b.png";